import type { Delivery, SearchExecution } from './types/entities';

/** Deliveries use `error_message` (DB column). Accept legacy `error` alias from older responses. */
export function normalizeDelivery<T extends Delivery>(
  row: T & { error?: string | null },
): T {
  const legacyError = row.error;
  return {
    ...row,
    error_message: row.error_message ?? legacyError ?? null,
  };
}

/** Search executions use `error` (DB column). Accept legacy `error_message` alias if present. */
export function normalizeSearchExecution(
  row: SearchExecution & { error_message?: string | null },
): SearchExecution {
  return {
    ...row,
    error: row.error ?? row.error_message ?? null,
  };
}
